import { faCheck, faDownload, faFile, faFilePdf, faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalCreateOrEditDevis from '../../views/Facturation/ModalCreateOrEditDevis';
import ModalDisplayDevisPDF from '../../views/Facturation/ModalDisplayDevisPDF';
import ModalCreateOrEditFacturation from '../../views/Facturation/ModalCreateOrEditFacturation';
import ModalGenerateSapXmlDocument from '../../views/Facturation/ModalGenerateSapXmlDocument';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { useAlert } from 'react-alert';
import MyDialog from '../Layout/MyDialog';
import { logError } from '../Utils/FormatData';
import ModalEditDevis from '../../views/Facturation/ModalEditDevis';
import { faClone } from '@fortawesome/free-regular-svg-icons';

const ActionsDevisRenderer = (props) => {
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [openModal4, setOpenModal4] = useState(false);
  const [openModal5, setOpenModal5] = useState(false);
  const [openModal6, setOpenModal6] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOnEdit = () => {
    setOpenModal(true);
  };
  const handleDelete = () => {
    setOpenDialog(true);
  };
  const onViewDevisBtnClick = () => {
    setOpenModal2(true);
  };
  const onDuplicateDevisBtnClick = () => {
    setOpenModal4(true);
  };

  const onDevisToFactureBtnClick = () => {
    setOpenModal6(true);
  }
  const onConfirmationModalClose = (value) => {
    if (value) {
      axios({ method: 'post', url: `${URL_API}/facturation/supprimer-facturation`, params: { id: props.data.id } })
        .then(() => {
          alert.removeAll();
          alert.success(`L'élément a bien été supprimé`);
          setOpenDialog(false);
          props.setReloadData(true);
        })
        .catch((error) => {
          logError(alert, error);
        });
    }
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) && ((props.data.type_facturation === 'devis' && !props.data.elements_factures?.status?.pdfAvailable) || (props.data.type_facturation === 'facture' && !props.data.elements_factures?.status?.pdfAvailable)) &&
          <div className='buttons-request-table' style={{ backgroundColor: '#f18d2d' }}>
            <FontAwesomeIcon icon={faPen} style={{ color: '#ffffff', height: '13px' }} onClick={handleOnEdit} />
          </div>
        }

        {(profil.profil === 1 || profil.profil === 2) &&
          props.data.elements_factures?.status?.statutDevis !== 'accepted' &&
          <div className='buttons-request-table' style={{ backgroundColor: '#d01818' }} onClick={handleDelete}>
            <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#ffffff', height: '13px' }} />
          </div>
        }

        {(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
          <div className='buttons-request-table' style={{ backgroundColor: '#f18d2d' }} onClick={onViewDevisBtnClick}>
            <FontAwesomeIcon icon={faFile} style={{ color: '#ffffff', height: '13px' }} />
          </div>
        }

       {props.data.type_facturation === 'devis' && props.data.elements_factures?.status?.pdfAvailable &&  props.data.elements_factures?.status?.statutDevis === 'accepted' && (profil.profil === 1 || profil.profil === 2) &&
          <div className='buttons-request-table' style={{ backgroundColor: '#0094ca' }}
               onClick={onDevisToFactureBtnClick}>
            <FontAwesomeIcon icon={faFilePdf} style={{ color: '#ffffff', height: '12px' }} />
          </div>
        }

        {(profil.profil === 1 || profil.profil === 2) &&
          <div className='buttons-request-table' style={{ backgroundColor: '#d01818' }}
               onClick={onDuplicateDevisBtnClick}>
            <FontAwesomeIcon icon={faClone} style={{ color: '#ffffff', height: '13px' }} />
          </div>
        }

        {profil.profil === 5 &&
          <>
            {props.data.elements_factures?.status?.pdfAvailable &&
              <div className='buttons-request-table' style={{ backgroundColor: '#f18d2d' }}
                   onClick={onViewDevisBtnClick}>
                <FontAwesomeIcon icon={faDownload} style={{ color: '#ffffff', height: '13px' }} />
              </div>
            }

            {/*{props.data.elements_factures?.status?.pdfAvailable && !props.data.elements_factures?.status?.statutDevis && props.data.type_facturation === 'devis' &&*/}
            {/*  <div className='buttons-request-table' style={{ backgroundColor: '#f18d2d' }}>*/}
            {/*    <FontAwesomeIcon icon={faCheck} style={{ color: '#ffffff', height: '13px' }} onClick={handleOnEdit} />*/}
            {/*  </div>*/}
            {/*}*/}
          </>
        }

      </div>
      {props.data.type_facturation === 'devis' &&
        <ModalCreateOrEditDevis
          openModal={openModal}
          setOpenModal={setOpenModal}
          color={'#0094ca'}
          user={user}
          facturation_id={props.data.id}
          type={props.data.type_facturation}
          setReloadData={props.setReloadData}
        />
      }

      {props.data.type_facturation === 'devis' &&
        <ModalCreateOrEditDevis
          openModal={openModal4}
          setOpenModal={setOpenModal4}
          color={'#0094ca'}
          user={user}
          facturation_id={props.data.id}
          dossier_id={null}
          facturation={props.data}
          type={props.data.type_facturation}
          setReloadData={props.setReloadData}
          duplication={true}
        />
      }
      {props.data.type_facturation === 'facture' && (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
        <ModalCreateOrEditFacturation
          openModal={openModal}
          setOpenModal={setOpenModal}
          color={'#0094ca'}
          user={user}
          facturation_id={props.data.id}
          type={props.data.type_facturation}
          setReloadData={props.setReloadData}
          devisId={props.data.elements_factures.devis}
        />
      }
      <ModalDisplayDevisPDF
        openModal={openModal2}
        setOpenModal={setOpenModal2}
        setOpenModalXml={setOpenModal3}
        setOpenModal5={setOpenModal5}
        color={'#0094ca'}
        user={user}
        facturation_id={props.data.id}
        type={props.data.type_facturation}
        setReloadData={props.setReloadData}
      />
      {profil.profil === 5 &&
        <ModalEditDevis
          openModal={openModal5}
          setOpenModal={setOpenModal5}
          color={'#0094ca'}
          user={user}
          facturation={props.data}
          profil={profil}
          setReloadData={props.setReloadData}
        />
      }

      {props.data.type_facturation === 'facture' && (profil.profil === 1 || profil.profil === 2) &&
        <ModalGenerateSapXmlDocument
          openModal={openModal3}
          setOpenModal={setOpenModal3}
          color={'#0094ca'}
          user={user}
          facturation_id={props.data.id}
          facturation={props.data}
          setReloadData={props.setReloadData}
        />
      }

      {
        (profil.profil === 1 || profil.profil === 2) &&
        <MyDialog
          open={openDialog}
          handleClose={setOpenDialog}
          title={`Voulez-vous vraiment supprimer ${props.data.type_facturation === 'devis' ? 'ce devis' : 'cette facture'} ?`}
          content={'Cette action est irréversible'}
          dialog={onConfirmationModalClose}
        />
      }

      {props.data.type_facturation === 'devis' &&
        <ModalCreateOrEditFacturation
          openModal={openModal6}
          setOpenModal={setOpenModal6}
          color={'#0094ca'}
          user={user}
          type={props.data.type_facturation}
          dossierId={props.data.dossier_id}
          devisId={props.data.id}
          setReloadData={props.setReloadData}
        />
      }

    </div>
  );

};

export default ActionsDevisRenderer;
